import React from 'react';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Typography,
  styled,
  Tooltip,
  tooltipClasses,
} from '@mui/material';
import { ACM } from '../../../constants/UserRoles';

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    fontWeight: 'bold',
    padding: '10px',
  },
}));

const ITEM_HEIGHT = 82;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
    },
  },
};

export default function PatientStudentSelector({
  typeOfUser,
  selectedPatient,
  selectedStudent,
  patientData,
  studentsGoalData,
  truncateName,
  setSelectedPatient,
  setSelectedStudent,
  isTeacherContext = false,
  currentEntity = null,
  selectionDisabled = false,
}) {
  const showTeacherSelector =
    isTeacherContext && ACM[typeOfUser]?.isTeacher;
  const showStudentSelector =
    !showTeacherSelector && ACM[typeOfUser]?.isTeacher;
  const teacherOptions =
    showTeacherSelector && Array.isArray(patientData) && patientData.length > 0
      ? [...patientData]
      : showTeacherSelector && currentEntity
      ? [{ ...currentEntity }]
      : [];
  return (
    <Box>
      <FormControl fullWidth>
        <Typography
          variant='h6'
          gutterBottom
          sx={{ 
            fontWeight: 900,
            color: '#333',
            mb: 2,
            fontSize: '1.1rem'
          }}
        >
          {showTeacherSelector
            ? 'Select Teacher'
            : ACM[typeOfUser]?.isDoctor
            ? 'Select Patient'
            : 'Select Student'}
        </Typography>
        {ACM[typeOfUser]?.isDoctor ? (
          <Select
            disabled={selectionDisabled || Boolean(selectedPatient)}
            key={selectedPatient}
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={selectedPatient}
            onChange={(e) => {
              setSelectedPatient(e.target.value);
            }}
            sx={{
              height: '46px',
              borderRadius: '8px',
              backgroundColor: 'var(--clr-mindly-white)',
              boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
            }}
            MenuProps={MenuProps}
          >
            {(Array.isArray(patientData) ? [...patientData] : [])
              .sort((a, b) =>
                (a?.fullname || a?.name || '')
                  .toLowerCase()
                  .localeCompare((b?.fullname || b?.name || '').toLowerCase())
              )
              .map((patient) => {
                return (
                  <MenuItem key={patient.id} value={patient?.id}>
                    {ACM[typeOfUser]?.isDoctor ? (
                      <BootstrapTooltip
                        title={
                          patient?.parentName
                            ? `${patient.fullname} (${patient.parentName})`
                            : patient?.fullname
                        }
                      >
                        {patient?.parentName
                          ? `${truncateName(patient.fullname)} (${truncateName(
                              patient.parentName
                            )})`
                          : `${truncateName(patient.fullname)}`}
                      </BootstrapTooltip>
                    ) : (
                      <BootstrapTooltip title={patient?.name}>
                        {patient?.name}
                      </BootstrapTooltip>
                    )}
                  </MenuItem>
                );
              })}
          </Select>
        ) : showTeacherSelector ? (
          <Select
            disabled={selectionDisabled}
            key={selectedStudent}
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={selectedStudent}
            onChange={(e) => {
              setSelectedStudent(e.target.value);
            }}
            sx={{
              height: '46px',
              borderRadius: '8px',
              backgroundColor: 'var(--clr-mindly-white)',
              boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
            }}
            MenuProps={MenuProps}
          >
            {teacherOptions
              .filter((teacher) => teacher?.id)
              .sort((a, b) =>
                (a?.fullname || a?.name || '')
                  .toLowerCase()
                  .localeCompare((b?.fullname || b?.name || '').toLowerCase())
              )
              .map((teacher) => (
                <MenuItem key={teacher.id} value={teacher.id}>
                  {teacher?.fullname || teacher?.name}
                </MenuItem>
              ))}
          </Select>
        ) : showStudentSelector ? (
          <Select
            disabled={selectionDisabled}
            key={selectedStudent}
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={selectedStudent}
            onChange={(e) => {
              setSelectedStudent(e.target.value);
            }}
            sx={{
              height: '46px',
              borderRadius: '8px',
              backgroundColor: 'var(--clr-mindly-white)',
              boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
            }}
            MenuProps={MenuProps}
          >
            {(Array.isArray(studentsGoalData) ? [...studentsGoalData] : [])
              .sort((a, b) =>
                (a?.fullname || '')
                  .toLowerCase()
                  .localeCompare((b?.fullname || '').toLowerCase())
              )
              .map((student) => (
                <MenuItem key={student.id} value={student.id}>
                  {student?.fullname}
                </MenuItem>
              ))}
          </Select>
        ) : null}
      </FormControl>
    </Box>
  );
}
